import { graphDefault, graphOverviewAxis } from './';
export const graphOverviewBorderLines = (theme, parameters) => {
  const overviewAxis = graphOverviewAxis(theme, parameters);
  const graphDefaultPattern = graphDefault(theme, parameters);
  const common = {
    lineThickness: overviewAxis.lineThickness,
    transparency: 0
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: graphDefaultPattern.p2
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: overviewAxis.lineColor
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: graphDefaultPattern.n2
        };
      }
  }
};
//# sourceMappingURL=graphOverviewBorderLines.js.map